KEY_ENTER = 13
KEY_ARROW_UP = 38
KEY_ARROW_DOWN = 40

TEMPLATES =
  main: require '../main.html.mustache'

module.exports = class FancyDropDown

  onChangeCallbacks: []

  constructor: ({ el, options }) ->
    @$el = $ el
    @render options

    @$dropDown = @$el.find '.fancy-drop-down'
    @$selected = @$el.find '.fancy-drop-down-selected'
    @$options = @$el.find '.fancy-drop-down-option'
    @$optionsWrapper = @$el.find '.fancy-drop-down-options'

    @bindings()

  render: (options) ->
    for option in options
      if option.isSelected is true
        @selected = option
        break

    radioName = "fancy-drop-down-#{(new Date().getTime())}"

    @$el.html TEMPLATES.main.render({ radioName, options, selected: @selected })

  value: ->
    @selected.value

  bindings: ->
    @$el.find('.fancy-drop-down-selected-and-arrow').click (evt) =>
      if @$dropDown.hasClass 'open'
        @hideOptions()
      else
        @showOptions()

    @$options.click (evt) =>
      # Avoid double click event when clicking a label.
      return if evt.target.nodeName is 'INPUT'
      @chooseOption $(evt.currentTarget)

  chooseOption: ($option) ->
    $input = $option.find 'input'
    text = $input.data 'text'
    value = $input.val()
    # Do not trigger a change event if the user selects the same option that is already selected.
    return if @selected.value is value

    @$options.removeClass 'checked'
    $option.addClass 'checked'

    @$selected.text text
    @selected = { text, value }

    cb({ text, value }) for cb in @onChangeCallbacks

  onChange: (cb) ->
    @onChangeCallbacks.push cb

  keyDown: (evt) =>
    switch evt.which
      when KEY_ARROW_DOWN
        @moveSelectionDown()
        evt.preventDefault()
      when KEY_ARROW_UP
        @moveSelectionUp()
        evt.preventDefault()
      when KEY_ENTER
        @chooseSelected()
        evt.preventDefault()

  showOptions: ->
    @$dropDown.addClass 'open'
    $(document).on 'keydown', @keyDown
    setTimeout (=> $(document).on 'click', @hideOptions), 1

  hideOptions: =>
    @$options.removeClass 'selected'
    @$dropDown.removeClass 'open'
    $(document).off 'keydown', @keyDown
    $(document).off 'click', @hideOptions

  highlightSelectedOption: (rowNumber) ->
    return unless @$options[rowNumber]?

    @$options.removeClass 'selected'
    $selected = $(@$options[rowNumber])
    $selected.addClass 'selected'

  # step should be a positive or negative number
  getNextHighlightedOptionNumber: (step) ->
    return null unless @$options.length > 0

    for i in [0..@$options.length]
      if $(@$options[i]).hasClass 'selected'
        selected = i
        break

    if not selected?
      if step > 0
        selected = -1
      else
        selected = 0

    number = ((selected + step) % @$options.length)
    number = @$options.length + number if number < 0
    number

  moveSelectionDown: ->
    number = @getNextHighlightedOptionNumber 1
    @highlightSelectedOption number

  moveSelectionUp: ->
    number = @getNextHighlightedOptionNumber -1
    @highlightSelectedOption number

  chooseSelected: ->
    $option = @$optionsWrapper.find '.fancy-drop-down-option.selected'
    @chooseOption $option
    @hideOptions()
